var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.273,20.667V18.778A3.8,3.8,0,0,0,12.455,15H4.818A3.8,3.8,0,0,0,1,18.778v1.889",
    transform: "translate(0 -0.667)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 3.818,
    cy: 3.778,
    rx: 3.818,
    ry: 3.778,
    transform: "translate(4.818 3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.864,20.674V18.785A3.785,3.785,0,0,0,20,15.13",
    transform: "translate(-0.864 -0.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16,3.13a3.768,3.768,0,0,1,0,7.319",
    transform: "translate(-0.682 -0.007)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.8e5f21fd3cf7d8eb69711175bdaed588.svg";
export { ForwardRef as ReactComponent };